import { isDefined } from '@sgme/fp';
import type { FieldMetadataById } from 'state/common-form/metaData/fields/fields.model';
import type { AppState } from 'state/state.model';
import { addKeys } from 'state/utils/collection';

export function getBatchFormFieldMetadata(state: AppState, formId: string): FieldMetadataById {
  return state.batchForm.metaData.fields[formId] ?? {};
}

export function getBatchFormMustForceAdvancedMode(state: AppState, formIds?: readonly string[]): boolean {
  if (state.batchForm.infos === undefined && state.batchForm.infos === null) {
    return false;
  }
  return Object.values(state.batchForm.infos ?? {})
    .filter(element => {
      const id = element.negotiationId;
      return isDefined(id) && formIds?.includes(id);
    })
    .some(element => element?.mustForceAdvancedMode === true);
}

export function getBatchFormsFieldMetadata(state: AppState, formIds: readonly string[]) {
  const data = formIds.map(id => getBatchFormFieldMetadata(state, id));
  return addKeys({}, formIds, data);
}

export function getBatchAllSolvableFieldIds(state: AppState, formId: string): readonly string[] {
  const fieldMetadata = getBatchFormFieldMetadata(state, formId);
  const solvableFieldIds = Object.values(fieldMetadata)
    .filter(metadata => metadata.solveBy && metadata.solveBy !== 'None' && !metadata.isHidden)
    .map(metadata => metadata.id);

  return solvableFieldIds;
}

export function getBatchFieldSolveBy(state: AppState, formId: string, fieldId: string): string | undefined {
  const fieldMetadata = getBatchFormFieldMetadata(state, formId);
  return fieldMetadata[fieldId].solveBy;
}
